import React, { useEffect, useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { useLocation, Link, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { get_sellers_email, place_order } from "../store/reducers/orderReducer";
import Loader from "../components/Loader";

const Shipping = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const {
    state: { products, price, shipping_fee, items },
  } = useLocation();

  const [res, setRes] = useState(false);
  const { sellerEmails } = useSelector((state) => state.order);

  const [isLoading, setIsLoading] = useState(false); // Manage loading state
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);

  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    province: "",
    city: "",
    area: "",
    post: "",
  });
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // UseEffect to dispatch get_sellers_email when products change
  useEffect(() => {
    const sellerIds = products.map((product) => product.sellerId);
    if (sellerIds.length > 0) {
      dispatch(get_sellers_email(sellerIds)); // Dispatch action to fetch seller emails
    }
  }, [products, dispatch]);

  const save = (e) => {
    e.preventDefault();
    const { name, email, phone, address, province, city, area, post } = state;
    if (name && email && phone && address && province && city && area && post) {
      setRes(true);
    }
  };
  const placeOrder = () => {
    setIsLoading(true); // Show loader

    dispatch(
      place_order({
        price,
        products,
        shipping_fee,
        shippingInfo: state,
        userId: userInfo.id,
        navigate,
        items,
        partner_emails: sellerEmails,
      })
    )
      .then((res) => {
        if (res.payload) {
          setIsOrderPlaced(true); // Disable the button
          setTimeout(() => {
            setIsLoading(false); // Hide loader after 3 seconds
          }, 3000);
        } else {
          setIsLoading(false); // Hide loader if an error occurs
        }
      })
      .catch((error) => {
        setIsLoading(false); // Ensure loader hides on error
        console.error("Order placement failed:", error);
      });
  };
  return (
    <div>
      {isLoading && <Loader />}
      <Headers />
      <section className="bg-[#eeeeee]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90] mx-auto py-16">
          {!userInfo ? (
            <div className="text-center py-10">
              <h2 className="text-slate-600 text-xl font-semibold">
                Veuillez vous connecter pour continuer
              </h2>
              <Link to="/login" className="mt-20 main-btn2">
                Se connecter
              </Link>
            </div>
          ) : (
            <div className="w-full flex flex-wrap">
              <div className="w-[67%] md-lg:w-full">
                <div className="flex flex-col gap-3">
                  <div className="bg-white p-6 shadow-sm rounded-2xl border border-mainColor">
                    {!res && (
                      <>
                        <h2 className="text-slate-600 font-bold pb-3">
                          Informations de paiement
                        </h2>
                        <form onSubmit={save}>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="name">Nom Complet</label>
                              <input
                                onChange={inputHandle}
                                value={state.name}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="name"
                                placeholder="name"
                                id="name"
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="email">Email</label>
                              <input
                                onChange={inputHandle}
                                value={state.email}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="email"
                                placeholder="votre email"
                                id="email"
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="phone">Téléphone</label>
                              <input
                                onChange={inputHandle}
                                value={state.phone}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="phone"
                                placeholder="phone"
                                id="phone"
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="address">Adresse</label>
                              <input
                                onChange={inputHandle}
                                value={state.address}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="address"
                                placeholder="maison / batiment / strreet /area"
                                id="address"
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="province">Pays</label>
                              <input
                                onChange={inputHandle}
                                value={state.province}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="province"
                                placeholder="country"
                                id="province"
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="city">Wilaya</label>
                              <input
                                onChange={inputHandle}
                                value={state.city}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="city"
                                placeholder="province"
                                id="city"
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="area">Ville</label>
                              <input
                                onChange={inputHandle}
                                value={state.area}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="area"
                                placeholder="city"
                                id="province"
                              />
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full">
                              <label htmlFor="post">Code postal</label>
                              <input
                                onChange={inputHandle}
                                value={state.post}
                                type="text"
                                className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                                name="post"
                                placeholder="post"
                                id="post"
                              />
                            </div>
                          </div>
                          <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                            <div className="flex flex-col gap-1 mt-3 w-full">
                              <button className="px-3 py-[6px] rounded-3xl hover:shadow-indigo-500/20 hover:shadow-lg bg-indigo-500 text-white">
                                Enregistrer
                              </button>
                            </div>
                            <div className="flex flex-col gap-1 mb-2 w-full"></div>
                          </div>
                        </form>
                      </>
                    )}
                    {res && (
                      <div className="flex flex-col gap-1">
                        <h2 className="text-slate-600 font-semibold pb-2">
                          Données du candidat: {state.name}
                        </h2>

                        <p>
                          <span className="bg-blue-200 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded">
                            Adresse
                          </span>
                          <span className="text-slate-600 text-sm">
                            {state.address} {state.province} {state.city}{" "}
                            {state.area}
                          </span>
                        </p>
                        <p>
                          <span
                            onClick={() => setRes(false)}
                            className="text-indigo-500 cursor-pointer border-b border-indigo-500"
                          >
                            {" "}
                            changer
                          </span>
                        </p>
                        <p className="text-slate-600 text-sm">
                          Nous envoyons un email de confirmation à{" "}
                          <span className="bg-blue-200 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded">
                            {" "}
                            {state.email}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                  {products.map((p, i) => (
                    <div
                      key={i}
                      className="flex bg-white p-4 flex-col gap-2 rounded-2xl border border-mainColor"
                    >
                      <div className="flex justify-start items-center">
                        <h2 className="text-md text-slate-600">{p.shopName}</h2>
                      </div>
                      {p.products.map((pt, j) => (
                        <div key={i + 99} className="w-full flex flex-wrap">
                          <div className="flex sm:w-full gap-2 w-7/12">
                            <div className="flex gap-2 justify-start items-center">
                              <img
                                className="w-[80px] h-[80px] rounded-md"
                                src={pt.productInfo.images[0]}
                                alt={pt.productInfo.name}
                              />
                              <div className="pr-4 text-slate-600">
                                <h2 className="text-md">
                                  {pt.productInfo.name}
                                </h2>
                                <span className="text-sm">
                                  Fournisseur : {pt.productInfo.brand}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end w-5/12 sm:w-full sm:mt-3">
                            <div className="pl-4 sm:pl-0">
                              <h2 className="text-lg text-green-500">
                                {pt.productInfo.price -
                                  Math.floor(
                                    (pt.productInfo.price *
                                      pt.productInfo.discount) /
                                      100
                                  )}{" "}
                                DA
                              </h2>
                              <p className="line-through">
                                {pt.productInfo.price} DA
                              </p>
                              <p>-{pt.productInfo.discount}%</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
              <div className="w-[33%] md-lg:w-full mt-3">
                <div className="pl-3 md-lg:pl-0">
                  <div className="bg-white font-medium p-5 text-slate-600 flex flex-col gap-3 rounded-2xl border border-mainColor">
                    <h2 className="text-xl font-semibold">
                      Résumé de la commande
                    </h2>
                    <div className="flex justify-between items-center">
                      <span>Sous-total </span>
                      <span>{price} DA</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span>Tax</span>
                      <span>{shipping_fee} DA</span>
                    </div>

                    <div className="flex justify-between items-center">
                      <span>Total</span>
                      <span>{price + shipping_fee} DA</span>
                    </div>
                    <button
                      onClick={placeOrder}
                      disabled={isOrderPlaced || isLoading} // Disable if loading or order placed
                      className={`main-btn2 ${
                        isOrderPlaced || isLoading
                          ? "bg-green-300 cursor-not-allowed"
                          : "bg-green-500"
                      } text-sm text-white uppercase`}
                    >
                      {isOrderPlaced ? "Commande placée" : "Passer la commande"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Shipping;
